import { SITE_VIEWPORT_SIZE_PRESETS } from '../../constants';
import { SiteViewportActionType } from './site-viewport-action-type';

export interface SetSiteViewportSizeAction {
  height?: number | string;
  type: SiteViewportActionType.SetSize;
  width?: number | string;
}

export const setSiteViewportSize = (
  size:
    | Partial<Pick<SetSiteViewportSizeAction, 'height' | 'width'>>
    | keyof typeof SITE_VIEWPORT_SIZE_PRESETS,
): SetSiteViewportSizeAction => {
  if (typeof size === 'string') {
    return {
      ...SITE_VIEWPORT_SIZE_PRESETS[size],
      type: SiteViewportActionType.SetSize,
    };
  } else {
    return {
      width: size.width,
      height: size.height,
      type: SiteViewportActionType.SetSize,
    };
  }
};
